import { NavigationModel } from "models/NavigationModel";
import { createContext } from "react";

export interface ILayoutContext {
  isFooterVisible: boolean;
  isHamburgerOpen: boolean;
  navItems: NavigationModel[];
  setIsFooterVisible: (visible: boolean) => void;
  setIsHamburgerOpen: (open: boolean) => void;
}

export const LayoutContext = createContext({} as ILayoutContext);
